import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

export default function GraficasMetricas({ productos }) {
  if (!productos || productos.length === 0) return null;

  const nombre = p => p.nombre?.split(" ").slice(0, 2).join(" ") ?? "—";

  const dataIngresos = productos
    .filter(p => p.ingresos_netos > 0)
    .sort((a, b) => b.ingresos_netos - a.ingresos_netos)
    .slice(0, 6)
    .map(p => ({ nombre: nombre(p), value: Math.round(p.ingresos_netos) }));

  const dataMargen = productos
    .filter(p => p.margen_real !== 0 || p.margen_potencial !== 0)
    .sort((a, b) => b.margen_potencial - a.margen_potencial)
    .slice(0, 5)
    .map(p => ({
      nombre: nombre(p),
      real: Math.round(p.margen_real),
      potencial: Math.round(p.margen_potencial),
    }));

  const colores = ["#1D9E75", "#378ADD", "#EF9F27", "#534AB7", "#E24B4A", "#888780"];

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
      <div className="card">
        <div className="card-title">Ingresos netos por producto</div>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={dataIngresos} layout="vertical" margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(136,135,128,0.2)" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 9, fill: "#888" }} tickFormatter={v => "$" + Math.round(v / 1000) + "K"} />
            <YAxis type="category" dataKey="nombre" tick={{ fontSize: 9, fill: "#888" }} width={80} />
            <Tooltip formatter={v => "$" + v.toLocaleString("es-CL")} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Bar dataKey="value" radius={[0, 3, 3, 0]}>
              {dataIngresos.map((_, i) => <Cell key={i} fill={colores[i % colores.length]} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="card">
        <div className="card-title">Margen real vs potencial</div>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={dataMargen} margin={{ top: 4, right: 4, left: -10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(136,135,128,0.2)" vertical={false} />
            <XAxis dataKey="nombre" tick={{ fontSize: 9, fill: "#888" }} interval={0} angle={-20} textAnchor="end" height={40} />
            <YAxis tick={{ fontSize: 9, fill: "#888" }} tickFormatter={v => "$" + Math.round(v / 1000) + "K"} />
            <Tooltip formatter={v => "$" + v.toLocaleString("es-CL")} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Bar dataKey="real"      name="Margen Real"      fill="#1D9E75" radius={[3, 3, 0, 0]} />
            <Bar dataKey="potencial" name="Margen Potencial" fill="#378ADD" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
        <div style={{ display: "flex", gap: 16, marginTop: 8, fontSize: 11, color: "#888" }}>
          <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: "#1D9E75", marginRight: 4 }} />Real</span>
          <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: "#378ADD", marginRight: 4 }} />Potencial</span>
        </div>
      </div>
    </div>
  );
}
